import { Route, Routes } from 'react-router-dom';
import { Subscription } from './Subscription';

export const SubscriptionRoutes = () => {
  return (
    <Routes>
      <Route index element={<Subscription />} />
    </Routes>
  );
};
